<template>
  <div>
    <modal-component v-if="showModal" @close="close()" :container-style="'width:90%'">
      <h3 slot="header"><strong>Subject:</strong> <span v-if="!isLoading">{{ subject }}</span></h3>

      <div slot="body">
        <div v-if="isLoading">
          <div class="text-center">
            <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div v-else class="card">
          <div class="card-header">
            <ul class="nav nav-tabs card-header-tabs pull-right" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="html-preview-tab" data-toggle="tab" href="#html-preview-panel" role="tab" aria-controls="html-preview-panel" aria-selected="false">E-mail</a>
              </li>
              <!-- <li class="nav-item">
                  <a class="nav-link" id="text-preview-tab" data-toggle="tab" href="#text-preview-panel" role="tab" aria-controls="text-preview-panel" aria-selected="false">TEXT</a>
              </li> -->
              <li class="nav-item">
                <a class="nav-link" id="form-preview-tab" data-toggle="tab" href="#form-preview-panel" role="tab" aria-controls="form-preview-panel" aria-selected="false">Form</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane show active" id="html-preview-panel" role="tabpanel" aria-labelledby="html-preview-tab">
                <div v-html="emailBody"></div>
              </div>
              <!-- <div class="tab-pane" id="text-preview-panel" role="tabpanel" aria-labelledby="text-preview-tab">
                  <pre class="pre-wrap" v-text="text"></pre>
              </div> -->
              <div class="tab-pane" id="form-preview-panel" role="tabpanel" aria-labelledby="form-preview-tab">
                <div class="card" v-if="checkin.form">
                  <div class="card-header">
                    <v-runtime-template
                      v-if="checkin.form.description"
                      :template="`<div>${checkin.form.description}</div>`"
                      class="mx-1 text-left"
                      ></v-runtime-template>
                  </div>
                  <div class="card-body">
                    <vue-form-generator ref="vfg" :schema="formSchema" :model="formModel" :options="formOptions"></vue-form-generator>
                    <!-- <div class="form">
                      <div v-for="(field, index) in checkin.form.schema" v-bind:key="index">
                          <strong>{{ field.label }}</strong>
                          <span v-if="field.type='input'">
                            <template v-if="field.inputType">{{ field.inputType }}</template>
                            <template v-else>input</template>
                          </span>
                          <span v-else>{{ field.type }}</span>
                          <span v-if="field.values">[{{ fieldOptionsList(field.values) }}]</span>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="card" v-else>
                  <div class="card-body">
                    This check-in doesn't have a form.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" @click="close()">Cancel</button>
        <button @click="sendCheckinEmail()" :disabled="isSending || !hasSendOnDate" class="btn btn-primary">
          <template v-if="checkin.sent_at">
            Re-send
          </template>
          <template v-else>
            Send Now
          </template>
          <i v-if="isSending" class="spinner-border" style="width: 1em; height: 1em; margin: 0 0 4px 4px"></i>
        </button>
      </div>
    </modal-component>
  </div>
</template>
<script>
import CheckinService from '@coach/js/services/CheckinService'
import VRuntimeTemplate from "v-runtime-template";
import VueFormGenerator from "vue-form-generator";
import { extractErrorMessage } from '../utils/helpers';
export default {
  props: [
    'show',
    'checkin',
  ],
  components: {
    "vue-form-generator": VueFormGenerator.component,
    VRuntimeTemplate,
  },
  data() {
    return {
      preview: null,
      showModal: this.show,
      isLoading: true,
      isSending: false,
      formModel: {},
      formSchema: {
        fields: null
      },
      formOptions: {
        fieldIdPrefix: 'vfg-'
      },
    }
  },
  mounted() {
    this.getEmailPreview();
  },
  computed: {
    subject: function() {
      return this.preview?.subject;
    },
    emailBody: function() {
      return this.preview?.html;
    },
    hasSendOnDate: function() {
      return !!this.checkin.send_on_date;
    }
  },
  methods: {
    init: function() {
      this.isLoading = true;
      this.isSending = false;
      this.getEmailPreview();
      this.setFormSchema();
      this.setFormModel();
    },
    close: function() {
      this.showModal = false;
      this.$emit('close');
    },
    sendCheckinEmail: function() {
      this.isSending = true;
      CheckinService.sendCheckinEmail(this.checkin.id)
        .then(response => {
          this.$toasted.success("Checkin Email Sent!")
          this.$emit('checkinEmailSent', response.data.data);
        })
        .catch(error => {
          console.log(extractErrorMessage(error));
          this.$toasted.error(extractErrorMessage(error));
          this.isSending = false;
        });
    },
    fieldOptionsList: function(values) {
      return values.map(function(a) {
          return a.name
        }).join(", ");
    },
    getEmailPreview: function() {
      if (this.checkin) {
        CheckinService.preview(this.checkin.id)
          .then(response => {
            this.preview = response.data.data;
            this.isLoading = false;
          })
          .catch(error => {
            console.log(error.data ? error.data.message : error);
            this.$toasted.error(error.data ? error.data.message : error);
            this.isLoading = false;
          });
      }
    },
    setFormSchema: function(){
      let schema = this.checkin?.form?.schema ?? null;
      if (schema) {
        schema.forEach(field => {
          if (typeof field.visible == "string" && field.visible.indexOf('function') >= 0) {
            field.visible = eval(field.visible); // convert from string to bool
          }
          if (typeof field.required == "string" && field.required.indexOf('function') >= 0) {
            field.required = eval(field.required); // convert from string to bool
          }
        });
      }

      this.formSchema.fields = schema ?? {};
    },
    setFormModel: function(){
      let values = {}; // _.omit(this.checkin, ['form']);
      values.weight_units = 'pounds'; //TODO: Make dynamic? Doesn't really matter right now.
      this.formModel = VueFormGenerator.schema.createDefaultObject(this.formSchema, values);
    }
  },
  watch: {
    show: function (newVal,oldVal) {
      Vue.set(this, 'showModal', newVal);
      this.init();
    }
  }
}
</script>
